export default function putnamReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_PUTNAM":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
